import emitter from 'tiny-emitter/instance'

// Using external library tiny-emitter for Vue3 future proofing
export const serverBus = {
    $on: (...args) => emitter.on(...args),
    $once: (...args) => emitter.once(...args),
    $off: (...args) => emitter.off(...args),
    $emit: (...args) => emitter.emit(...args)
};